import { Box } from '@factorialco/deprecated-design-system'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { InvoiceDetailContent } from 'modules/finance/components/Invoices/Detail/Content'
import { Header } from 'modules/finance/components/Invoices/Detail/Header'
import { InvoiceViewerLayout } from 'modules/finance/components/Invoices/Detail/InvoiceViewerLayout'
import { useInvoiceDetail } from 'modules/finance/hooks/useInvoiceDetail'
import { isInvoiceDeletable } from 'modules/finance/lib/invoices'
import Loading from 'modules/layout/components/Page/Loading'

export interface InvoiceDetailPanelProps {
  invoiceId: number
  onClose: () => void
  onDelete?: () => void
}

export const InvoiceDetailPanel = ({ invoiceId, onClose, onDelete }: InvoiceDetailPanelProps) => {
  const { company } = useCurrentSession()

  const {
    invoice,
    financialDocumentsPaymentsAvailable,
    isJournalEntriesManagementFeatureAvailable,
    isSoftwareModuleEnabled,
    isProcurementModuleEnabled,
    isProjectsModuleEnabled,
    isExpensesModuleEnabled,
    legalEntities,
    taxTypes,
    file,
    canManageJournalEntries,
    reconciliationsSeeFinancialDocumentsPage,
    reconciliationsSeeJournalEntriesPage,
    loading,
    journalLines,
    journalEntries,
  } = useInvoiceDetail({ invoiceId, companyId: company.id })

  if (loading) return <Loading />
  if (!invoice) return <NotFound />

  return (
    <>
      {file && (
        <InvoiceViewerLayout
          onClose={onClose}
          filename={String(file.filename)}
          contentType={String(file.contentType)}
          url={String(file.url)}
          isUrlAbsolute
          content={
            <Box aria-label="invoiceSidepanel" overflowY="auto" style={{ height: '100vh' }}>
              <Box position="relative">
                <Header
                  onDelete={onDelete}
                  onClose={onClose}
                  canDelete={isInvoiceDeletable(invoice)}
                />
              </Box>
              <InvoiceDetailContent
                invoice={invoice}
                legalEntities={legalEntities}
                onClose={onClose}
                showSendToPayButton={financialDocumentsPaymentsAvailable}
                showReconciliationSection={isJournalEntriesManagementFeatureAvailable}
                showExpense={isExpensesModuleEnabled}
                showSoftware={isSoftwareModuleEnabled}
                showPurchaseOrder={isProcurementModuleEnabled}
                showProjects={isProjectsModuleEnabled}
                taxTypes={taxTypes}
                canManageJournalEntries={canManageJournalEntries}
                canReconcileWithJournalLines={reconciliationsSeeJournalEntriesPage}
                canReconcileWithFinancialDocuments={reconciliationsSeeFinancialDocumentsPage}
                journalLines={journalLines}
                journalEntries={journalEntries}
              />
            </Box>
          }
        />
      )}
    </>
  )
}
